module.exports = __webpack_public_path__ + "img/activities-21.bbba269b.jpg";